RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const POST_DIMENSION_MAX_VISUAL_EXPORT_ROWS = 200;

    const Dashboard = RivalIQ.apps.Dashboard;

    const ManageColumnsBtn = RivalIQ.views.Link.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        linkName: 'Manage Columns...',
        className: 'btn btn-default btn-xs',
        action: function () {
            const me = this;
            const metric = me.dashboardModel.metric;

            RivalIQ.execute('show:modal', new Dashboard.widgets.table.ColumnPicker({
                metric: metric.build({
                    limit: 1
                }),
                model: me.dashboardModel
            }));
        }
    });

    const MAX_EXPORT_COLUMNS = 10;

    const Panel = widgets.PostDimensionDetailsPanel = Dashboard.views.Panel.extend({
        showActions: function () {
            const me = this;

            if (!(me.getProp('hideManageColumns'))) {
                me.actions.show(new ManageColumnsBtn({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });
            }

            if (!me.dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        }
    });

    const PostDimension = widgets.PostDimension = RivalIQ.apps.Dashboard.models.Widget.extend({
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.CSV
        ],
        csvExportProps: csvExportProps,
        propsToSerializeForExport: App.utils.widgetExportProps,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        getSlideElements: App.utils.getSlideElements,
        getFilename: function () {
            const me = this;
            const companyId = me.getProp('focusCompanyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return RivalIQ.export.filename.base({
                title: me.getFilenameTitle(),
                companyName: company.get('name')
            });
        },
        hasFooter: _.constant(true), // always show the legend, even in export
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    widgets.PostDimensionTable = PostDimension.extend({
        propsToSerialize: ['metrics'],
        // NOTE we need to use a list of allowed props during serialization so that
        // we don't erroneously persist props (e.g., `searchTerm`, `dimension`)
        // see #14940 for more information
        getPropsForSerialization: function (props) {
            const me = this;
            return _.pick(props, me.propsToSerialize);
        },
        propsToSerializeForExport: App.utils.widgetExportProps.concat('metrics'),
        getVisualExportLimit: function (props) {
            let limit = props.limit;

            if (!_.isUndefined(limit)) {
                // double check this
                if (!_.isFinite(limit)) {
                    limit = -1;
                }

                if (limit === -1) {
                    limit = POST_DIMENSION_MAX_VISUAL_EXPORT_ROWS;
                }
                limit = Math.min(limit, POST_DIMENSION_MAX_VISUAL_EXPORT_ROWS);
            }

            return limit;
        },
        exportProps: function (props) {
            const me = this;
            props.metrics = props.metrics.slice(0, MAX_EXPORT_COLUMNS);
            props.limit = me.getVisualExportLimit(props);
            return me.mixins.Export.exportProps.call(me, props);
        },
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                orderBy: [1, 2],
                sortOrder: 1,
                showDescriptions: true
            });

            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.normalizeMetricColumns(props);

            return props;
        },
        getView: function () {
            return RivalIQ.apps.Dashboard.widgets.MetricTable;
        },
        panelView: Panel,
        detailPanelView: Panel,
        allowPageBreaks: function () {
            const me = this;
            const limit = me.getProp('limit');
            return limit === -1 || limit === POST_DIMENSION_MAX_VISUAL_EXPORT_ROWS;
        },
        getBreakdownDimensions: _.noop
    });

    function csvExportProps(props) {

        const me = this;

        return {
            type: 'metric',
            metric: me.metric.build({
                limit: -1,
                sortOrder: props.sortOrder,
                orderBy: me.metricsCollection.getOrderBy(props.orderBy),
                dimensions: (props.dimension ? [props.dimension] : undefined)
            }).serialize()
        };
    }

});
